export default __webpack_public_path__ + "static/media/sana3.7fe0a04b.jpg";